import { Filter, PaginatedResponse } from '@libs/models/common';
import { filterToQueryParams } from '../utils/filterToQueryParams';
import { FacilityTypes } from './mocks';
import { FacilityTypesListItem } from '@libs/models/facilities';

type fetchAgenciesListParams = {
  search?: string;
  page?: number;
  size?: number;
  filters?: Filter[];
};
export async function fetchFacilityTypesList(
  params?: fetchAgenciesListParams,
): Promise<PaginatedResponse<FacilityTypesListItem[]>> {
  const filters = filterToQueryParams((params?.filters ?? []).map((fil) => ({ field: fil.key, value: fil.value })));

  // const response = await request.get<PaginatedResponse<FacilityTypesFetchItem[]>>('/facilities', {
  //   params: {
  //     pageNumber: params?.page || 1,
  //     pageSize: params?.size || 50,
  //     search: params?.search || undefined,
  //     ...filters,
  //   },
  // });

  const fake = async () =>
    new Promise<PaginatedResponse<FacilityTypesListItem[]>>((resolve) => {
      setTimeout(() => {
        resolve({
          // ...response.data,
          hasNextPage: false,
          hasPreviousPage: false,
          pageNumber: 1,
          pageSize: FacilityTypes.length,
          totalCount: FacilityTypes.length,
          items: FacilityTypes,
        });
      }, 1000);
    });

  return await fake();
}
